import { highD, lowB, mediumC, veryHighE, veryLowA } from "../graphs/colors";

export const ratingColors: {
  [key: string]: string;
} = {
  veryLow: veryLowA,
  low: lowB,
  medium: mediumC,
  high: highD,
  veryHigh: veryHighE,
};
